import { render, staticRenderFns } from "./PostalCodeListFilter.vue?vue&type=template&id=189dab46"
import script from "./PostalCodeListFilter.vue?vue&type=script&lang=js"
export * from "./PostalCodeListFilter.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeListFilter.vue?vue&type=style&index=0&id=189dab46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports